export enum ConversionStepsEnum {
  CONFIRM = 1,
  CALCULATOR,
  FINISH
}

export enum PackageTypeEnum {
  GAMING = 1,
  STACKING
}
